import { RichTextValue } from '@/components';
import { useGetAnnouncementDetailsQuery } from '@/redux/announcements';
import { Tag } from 'antd';
import { formatters } from '@/core';

interface Props {
  id: string;
}

export function AnnouncementOverviewDetailsPanel(props: Props) {
  const { id } = props;
  const { data } = useGetAnnouncementDetailsQuery({ id });

  if (!data) {
    return null;
  }

  return (
    <>
      <Tag color="blue" className="ms-3 mb-3">
        {formatters.dateTime(data.period.start, 'date')}
        {data.period.end ? ` - ${formatters.dateTime(data.period.end, 'date')}` : ''}
      </Tag>
      <RichTextValue
        label={false}
        value={data.body}
        ownerId={id}
        ownerType="Announcement"
      />
    </>
  );
}

